import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {CustomValidator} from '../../../../services/custom-validator';
import {Encodings} from '../../../../services/encodings';
import {BatchService} from '../../../../services/batch.service';
import {NodeConfigurationType} from '../../../../Models/enum/nodeConfigurationType';
import {DateTimeService} from '../../../../services/date-time.service';
import {UploadFilesService} from '../../../../services/upload-files.service';
import {HttpEventType} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {until} from 'selenium-webdriver';
import elementTextContains = until.elementTextContains;

@Component({
  selector: 'app-batch-management-modal',
  templateUrl: './batch-management-modal.component.html',
  styleUrls: ['./batch-management-modal.component.css']
})
export class BatchManagementModalComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState;
  fileErrorMessage = '';
  fileErrorTimer;
  errorMessage = '';
  successMessage = '';
  submitClick = false;
  batchManagementForm: FormGroup;
  itemSaved: Subject<boolean> = new Subject<boolean>();
  layouts: {list: any[], loading: boolean, loadError: string} = { list: null, loading: false, loadError: '' };
  serviceNodes: {list: any[], loading: boolean, loadError: string} = { list: null, loading: false, loadError: ''};
  finalStates = [];
  executingUsers = [];
  postBatchBusinessProcesses = [];
  encodings = Encodings.list;
  files: any[] = [];
  minDate = this.dateTimeService.formatDateTimePickerFormat(new Date());
  sessionId;

  get formData() {
    return this.batchManagementForm.controls;
  }

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef, private batchService: BatchService,
              private dateTimeService: DateTimeService, private fileUploadService: UploadFilesService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.createForm();
    this.loadBatchLayoutList();
    this.loadBatchServiceNodeList();
    if (this.objInitialState) {
      this.sessionId = this.objInitialState;
    }
  }

  createForm() {
    this.batchManagementForm = this.formBuilder.group({
      name: ['', [ Validators.required, Validators.maxLength(100), CustomValidator.onlyStringAndNumbersAccepted ]],
      layoutId: [null, [ Validators.required ]],
      executionUserLogon: [ { value: null, disabled: true }, [ Validators.required ]],
      batchServiceAgentName: [null, [ Validators.required ]],
      fileEncoding: ['us-ascii', [ Validators.required ]],
      finalStateName: [ { value: null, disabled: true } ],
      finishedBatchBusinessProcessName: [ { value: null, disabled: true } ],
      scheduleDate: null
    })
  }

  fileChange(element){
    const pFileList: File[] = element.target.files;

    this.fileErrorMessage = '';
    clearTimeout(this.fileErrorTimer);

    // recuperando os arquivos
    let selectedNewFiles = Object.keys(pFileList).map(key => pFileList[key]);

    // verificar geral se o(s) arquivo(s) já existe(m)
    const existFiles = selectedNewFiles.filter(f => this.files.map(m => m.name).indexOf(f.name) !== -1 );
    if (existFiles.length > 0) {
      const filesName = existFiles.map(m => m.name).join(', ');
      if (existFiles.length > 1) {
        this.fileErrorMessage = `Os arquivos ${filesName} já foram adicionados.`;
      } else {
        this.fileErrorMessage = `O arquivo ${filesName} já foi adicionado.`;
      }

      // manter somente os novos arquivos no array
      selectedNewFiles = selectedNewFiles.filter(f => this.files.map(m => m.name).indexOf(f.name) === -1 );
      this.fileErrorTimer = setTimeout(() => { this.fileErrorMessage = ''; }, 10000);
    }

    // verificar se são arquivos com extensões aceitas
    const acceptableExt = ['txt', 'xls', 'xlsx', 'csv'];
    let invalidFiles = [];

    // aqui terá somente os arquivos novos...
    selectedNewFiles.forEach(( item, index ) => {
      item.isUploading = false;
      if (acceptableExt.indexOf(item.name.split('.').pop()) < 0) {
        invalidFiles.push(item.name);
      } else {
        const objURL = window.URL.createObjectURL(item);
        const sanitizedFile = this.sanitizer.bypassSecurityTrustUrl(objURL);


        this.fileUploadService.uploadFile(this.sessionId, item)
          .subscribe(res => {
              switch (res.type) {
                case HttpEventType.Sent:
                  break;
                case HttpEventType.UploadProgress:
                  var eventTotal = res.total ? res.total : 0;
                  item.isUploading = true;
                  item.progressBarFile = Math.round(res.loaded / eventTotal * 100);
                  break;
                case HttpEventType.Response:
                  const responseEncoding = res.headers.get('encoding');
                  item.encoding = responseEncoding;
                default:
                  item.isUploading = false;
                  item.canDelete = true;
                  setTimeout(() => {
                    item.progressBarFile = 0;
                  }, 1500);
                  break;
              }
            },
            error1 =>  {
              // se deu erro, devo inserir um status
              item.fileError = true;
              let err = error1;
              if (error1.indexOf('401') !== -1) {
                err = 'Erro: Sessão expirada.';
              }
              this.fileErrorMessage = err;
              console.log(err);
            });
      }
    });

    if (this.files.length == 0){
      this.files = Object.keys(pFileList).map(key => pFileList[key]);
    } else {
      this.files = this.files.concat(selectedNewFiles);
    }

    this.setInvalidFiles(invalidFiles);
    element.target.value = '';

  }

  setInvalidFiles(invalidFiles) {
    if (invalidFiles.length > 0) {
      const splitedFiles = invalidFiles.join(', ');

      if (invalidFiles.length > 1) {
        this.fileErrorMessage = `Arquivos não permitidos ${splitedFiles}`;
      } else {
        this.fileErrorMessage = `Arquivo não permitido ${splitedFiles}`;
      }

      this.fileErrorTimer = setTimeout(() => { this.fileErrorMessage = ''; }, 10000);
      this.files = this.files.filter(f => invalidFiles.indexOf(f.name) === -1);
    }
  }

  deletionInfo(fileName, isExclusion = true) {
    this.fileErrorMessage = '';
    if (isExclusion) {
      this.fileUploadService.deleteFile(this.sessionId, fileName).subscribe(res => {
        if (res) {
          this.files = this.files.filter(f => f.name !== fileName);
        }
      }, error1 => this.fileErrorMessage = error1);
    } else {
      this.files = this.files.filter(f => f.name !== fileName);
    }
  }

  layoutChange(element) {
    if (element !== undefined) {
      this.loadUsers(element.batchTemplateId);
      this.loadStatesByBusinessProcess(element.businessProcessId);
    } else {
      this.executingUsers = [];
      this.finalStates = [];
      this.setEnableField('executionUserLogon', false);
      this.setEnableField('finalStateName', false);
    }
  }

  setEnableField(formControlName: string, enable: boolean) {
    if (enable) {
      this.batchManagementForm.get(formControlName).enable();
    } else {
      this.batchManagementForm.get(formControlName).setValue(null);
      this.batchManagementForm.get(formControlName).disable();
    }
  }

  userChange(element) {
    if (element !== undefined) {
      this.loadPostBatchBusinessProcesses(element.logon);
    } else {
      this.postBatchBusinessProcesses = [];
      this.setEnableField('finishedBatchBusinessProcessName', false);
    }
  }

  loadBatchLayoutList() {
    this.layouts = {
      list: null,
      loading: true,
      loadError: ''
    };

    this.batchService.getAllBatchTemplates().subscribe(res => {
      this.layouts.list = res;
      this.layouts.loading = false;
    }, error1 => {
      this.layouts.loadError = error1;
      this.layouts.loading = false;
    });
  }

  loadBatchServiceNodeList() {
    this.serviceNodes = {
      list: null,
      loading: true,
      loadError: ''
    };

    this.batchService.getAllConfigurationNodesByType(NodeConfigurationType.Batcher)
      .subscribe(res => {
        this.serviceNodes.list = res;
        if (this.serviceNodes.list.length > 0) {
          this.serviceNodes.list.forEach(item => {
            item.label = `${item.machineId} em ${item.hostName}`;
          });
        }
        this.serviceNodes.loading = false;
      }, error1 => {
        this.serviceNodes.loadError = error1;
        this.serviceNodes.loading = false;
      });

  }

  loadUsers(batchTemplateId: number) {
    this.errorMessage = '';
    this.batchManagementForm.get('executionUserLogon').disable();
    this.batchService.getUsersByBatchTemplateBusinessProcess(batchTemplateId)
      .subscribe(res => {
        this.executingUsers = res;
        this.batchManagementForm.get('executionUserLogon').enable();
      }, error1 => this.errorMessage = error1);
  }

  loadStatesByBusinessProcess(businessProcessId: number) {
    this.errorMessage = '';
    this.batchManagementForm.get('finalStateName').disable();
    this.batchService.getStatesByPublishedBusinessProcess(businessProcessId)
      .subscribe(res => {
        this.finalStates = res;
        this.setEnableField('finalStateName', true);
      }, error1 => this.errorMessage = error1);
  }

  loadPostBatchBusinessProcesses(userLogon: string) {
    this.errorMessage = '';
    this.batchManagementForm.get('finishedBatchBusinessProcessName').disable();
    this.batchService.getBusinessProcessesForStartByUser(userLogon)
      .subscribe(res => {
        this.postBatchBusinessProcesses = res;
        this.setEnableField('finishedBatchBusinessProcessName', true);
      }, error1 => this.errorMessage = error1);
  }

  validateFileQueue() {
    const totalFiles = this.files.length;
    var countErrors = this.files.filter(f => f.fileError).length;
    if (totalFiles == countErrors) {
      return false;
    }

    return totalFiles !== countErrors;
  }

  adjustDate() {
    const dateNow = this.dateTimeService.formatDateTimePickerFormat(new Date());
    let scheduleDate = this.formData.scheduleDate.value;

    if (scheduleDate !== null && scheduleDate !== '') {
      scheduleDate = this.dateTimeService.formatDateTimePickerFormat(scheduleDate);

      if (scheduleDate < dateNow) {
        this.formData.scheduleDate.setValue(dateNow);
      }
    }

  }

  onSave() {
    this.errorMessage = '';
    this.successMessage = '';
    this.submitClick = true;
    this.adjustDate();
    const parameters = this.batchManagementForm.getRawValue();
    parameters.scheduleDate = parameters.scheduleDate == '' ? null : this.dateTimeService.toUTC(parameters.scheduleDate);

    this.batchService.submitBatch(parameters, this.sessionId).subscribe(res => {
      this.submitClick = false;
      this.itemSaved.next(true);
      this.successMessage = 'Lote criado com sucesso.';
      setTimeout(() => {
        this.successMessage = '';
        this.bsModalRef.hide();
      }, 2000)

    }, error1 => {
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.errorMessage = err;
      this.submitClick = false;
    });
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  blockUserInput() {
    return false;
  }

}
